'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _TransmuteCollection = require('./TransmuteCollection');

_TransmuteCollection.some.implement(Array, function (predicate, arr) {
  return arr.some(predicate);
});

_TransmuteCollection.some.implementInherited(_immutable.Iterable, function (test, iter) {
  return iter.some(test);
});

_TransmuteCollection.some.implement(Object, function (predicate, obj) {
  var keys = Object.keys(obj);
  var len = keys.length;
  for (var i = 0; i < len; i++) {
    var key = keys[i];
    if (predicate(obj[key], key, obj)) {
      return true;
    }
  }
  return false;
});

exports.default = _TransmuteCollection.some;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/internal/_some.js
// module id = 365
// module chunks = 0 1